import { Box, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const CompanyRegistrationNumber = ({
    state,
    onChange,
    stateError,
    darkMode,
    walkthroughId,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={stateError?.abn}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={stackStyling()}>
                <Box width={190}>
                    <FormLabel
                        sx={{
                            ...formLabelStyling(darkMode),
                            minW: '190px',
                            overflowWrap: 'break-word',
                            whiteSpace: 'normal',
                            paddingY: '15px',
                        }}>
                        Company Registration Number
                    </FormLabel>
                </Box>
                <Field
                    component={NameField}
                    width={520}
                    id="abn"
                    name="abn"
                    value={state?.abn}
                    onChange={onChange}
                    walkthroughid={walkthroughId}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Your company registration number"
                        ariaLabel="crn-tip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default CompanyRegistrationNumber;
